
import React, {Component, ReactDOM} from 'react';
import { Link, withRouter } from "react-router-dom";
import styled from 'styled-components'

// image
// import logo from '../asset/image/logo.png'
// import blog from '../asset/image/blog_icon.png'
// import instagram from '../asset/image/instagram_icon.png'

const FooterContainer = styled.div`
    color: black;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    margin-top: auto;
    flex-direction: column;
    /* position: fixed;
    bottom: 0; */
    background-color: #1E252B;
    padding-top: 40px;
    padding-bottom: 20px;
    @media (max-width: 768px) {
      padding: 20px 20px 20px;
    }
  `
  // border-bottom: 1px solid #ccc;

const List = styled.ul`
  width: 678px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  /* padding: 0 20px 20px; */
  margin: 0 20px 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  @media (max-width: 768px) {
    flex-direction: row;
    width: 100%;
    margin: 0 20px 20px;
    padding-bottom: 20px;
  }
`;

const Item = styled.li`
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  @media (max-width: 768px) {
    /* margin-bottom: 30px; */
    flex-direction: column;
  }
`;

const SNSlinkImageWrap = styled.div`
  
  flex-direction: row;
  display: none;
  @media (max-width: 1024px) {
    display: flex;
  }
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0px;
    right: 0px;
  }
`

const ItemSNS = styled.li`
  height: 100%;
  flex: 1;
  @media (max-width: 1024px) {
    display: none;
  }
`

const SNSlinkImageContainer = styled.div`
  width: 62px;
  height: 62px;
  margin-right: 20px;
  @media (max-width: 1024px) {
    width: 50px;
    height: 50px;
    margin-top: 30px;
  }
  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
  }
`

const Image = styled.img`
  height: 30px;
`

const FooterSubTextBold = styled.p`
  font-size: 14px;
  color: white;
  font-weight: 500;
  line-height: 20px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`

const FooterSubTextRegular = styled.p`
  font-size: 14px;
  color: white;
  font-weight: 300;
  line-height: 24px;
  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 12px;
  }
`

const FooterSubTextPhoneRegular = styled.a`
  font-size: 14px;
  color: white;
  font-weight: 300;
  line-height: 24px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`

const FooterText = styled.p`
  font-size: 16px; 
  margin-bottom: 15px;
  line-height: 24px;
  color: white;
  font-weight: bold;
  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 14px;
    line-height: 12px;
  }
`

const FooterCopy = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`

export default withRouter(({ location: { pathname } }) => {
  return (
    <>
    {(pathname === '/signin' || pathname === '/signup' || pathname === '/shop/profile') ? (
      null
    ) : (
      <FooterContainer>
        <List>
          <Item style={{flex: 3}}>
            <FooterText>(주)얼마야</FooterText>
            <div style={{marginBottom: 8}}>
              <FooterSubTextRegular>서울시 강남구 가로수길 55 3층 트레져러</FooterSubTextRegular>
            </div>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <FooterSubTextRegular>사업자 등록번호 : </FooterSubTextRegular>
              <FooterSubTextRegular>527 - 81 - 01503 | 대표 : 김경태</FooterSubTextRegular>
            </div>
          </Item>
          <Item style={{flex: 1, width: '100%'}}>
            <FooterText>COMPANY</FooterText>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
              <div style={{display: 'flex', flex: 1}}>
                <FooterText>직토</FooterText>
                {/* <FooterSubTextRegular></FooterSubTextRegular> */}
              </div>
              <div style={{display: 'flex', flex: 1}}>
                <FooterText>얼마야</FooterText>
                {/* <FooterSubTextRegular></FooterSubTextRegular> */}
              </div>
            </div>
          </Item>
        </List>
        <FooterCopy>
          Copyrightⓒ2021 (주)얼마야 All rights reserved.
        </FooterCopy>
      </FooterContainer>
    )}
    </>
  )
});
